import './index.erb';
import './index.rb';
import ConsentManager from 'utils/consent_manager';

class CookiesAgreement {
  constructor() {
    this.cookiesBar = $('.js-cookies-agreement');
    this.acceptButton = $('.js-allow-cookies');
    this.status = this.cookiesBar.data('status');

    if(this.status === 'enabled') {
      this.bind();
      this.process();
    }
  }

  async accept() {
    ConsentManager.accept(window.currentUser);
    this.cookiesBar.hide();
  }

  process() {
    if (ConsentManager.isAccepted()) {
      this.cookiesBar.hide();
    } else {
      this.cookiesBar.show();
    }
  }

  bind() {
    this.acceptButton.on('click', e => this.accept());
  }
}



(() => {
  document.addEventListener("turbolinks:load", () => {
    new CookiesAgreement();
  });
})();
